<template>

    <el-container class="home-container">
      <el-header>
         <div>
            <img src="../assets/logo.png" alt="">
            <span>短链接管理系统</span>
         </div>
         <div style="margin-left:66%;margin-bottom:8px;font-size:14px!important;color:#555;">
            <span v-if="ids==='1'" style="margin-right:10px;">超级管理员: {{user_name}}</span>
            <span v-else style="margin-right:10px;">子管理员: {{user_name}}</span>
         <el-button  type="danger" @click="ShowEditLink">修改密码</el-button>
         </div>
         <el-button  type="info" @click="logout">退出</el-button>
      </el-header>

      <el-dialog
      title="管理员密码"
      :visible.sync="dialogEditLink"
      width="30%">
         <el-form ref="editFormRef" :model="edit_form" :rules="myrules" class="add_form">
               <!--用户名-->
               <el-form-item label="用户名">
                  <el-input v-model="edit_form.user_name" :disabled = "true"></el-input>
               </el-form-item>
               <!--密码-->
               <el-form-item label="修改密码" prop="password">
                  <el-input v-model="edit_form.password" type="password"></el-input>
               </el-form-item>
               <!--按钮-->
         </el-form>
         <span slot="footer" class="dialog-footer">
         <el-button @click="dialogEditLink = false">取 消</el-button>
         <el-button type="primary" @click="EditLinkConfirm">确 定</el-button>
         </span>
     </el-dialog>

      <el-container>
         <el-aside :width="isCollapse ? '64px' :'200px'">
            <div class="toggle-button" @click="toggled">|||</div>
            <el-menu 
               background-color="#545c64"
               text-color="#fff"
               active-text-color="#ffd04b"
               unique-opened
               :collapse="isCollapse"
               :collapse-transition="false"
               router
               default-active='/link'
            >
               <el-submenu index="1">
               <template slot="title">
                  <i class="el-icon-s-tools"></i>
                  <span>链接管理</span>
               </template>
              <el-menu-item index="/link">
                  <template slot="title">
                     <i class="el-icon-connection"></i>
                     <span>操作</span>
                  </template>
              </el-menu-item>
               </el-submenu>
            </el-menu>
         </el-aside>
         <el-main>
            <router-view></router-view>
         </el-main>
      </el-container>
    </el-container>

</template>
<script>
import axios from 'axios';
export default {
   data() {
      return {
         ids:window.sessionStorage.getItem('ids'),
         user_name:window.sessionStorage.getItem('user_name'),
         isCollapse:false,
         dialogEditLink:false,
         edit_form:{
            id:'',
            user_name:'',
            password:''
         },
         myrules:{
         password:[
               {required:true,message:'请输入密码',trigger:'blur'},
               {min:6,max:15,message:'长度在 6 到 15 个字符',trigger:'blur'}
         ]
         }
      }
   },
   methods:{

      logout(){
         window.sessionStorage.clear();
         this.$router.push('/login');
      },
      toggled(){
         this.isCollapse = !this.isCollapse
      },
      ShowEditLink(){
      this.dialogEditLink = true;
      axios({
        method: "post",
        url: "http://144.202.120.54/api/Login/adminEditSearch",
        params: {
          id: window.sessionStorage.getItem('ids')
        }
      }).then((res) => {

          if(res.data.code == 0){
            this.$message.error('无此数据!');
            return false;
          }

          if(res.data.code ==200){
            this.edit_form.id = res.data.data.id;
            this.edit_form.user_name = res.data.data.user_name;
          }
      });
    },
    EditLinkConfirm(){
      this.dialogEditLink = false;
      this.EditLink();
    },
    EditLink(){
      this.$refs.editFormRef.validate(async valid=>{
         if(!valid) return;
           const formData = this.edit_form; // 获取表单数据
           axios({
              method: "post",
              url: "http://144.202.120.54/api/Login/editAdmin",
              params: {
                id: this.edit_form.id,
                password: this.edit_form.password
              }
            }).then((res) => {
          
                if(res.data.code == 0){
                  this.$message.error('暂无修改!');
                  return false; 
                } 
                if(res.data.code ==200){
                  this.$message.success('修改成功!');
                }
            });
         });  
    }
   }
}
</script>

<style lang="less" scoped>
.el-header{
   background-color: #B3C0D1;
   color: #000;
   font-size: 24px;
   font-weight: bold;
   display: flex;
   justify-content: space-between;
   padding-left: 10px;
   align-items: center;
   >div{
      display: flex;
      align-items: center;
      margin-top:10px;
      margin-left: 15px;
   }
}
.el-header img{
   width: 50px;
   height: auto;
}
.el-aside{
   background-color: #D3DCE6;
   color: #333;
   line-height: 200px;
   text-align: center;
}
.el-main{
   background-color: #E9EEF3;
   color: #333;
   text-align: center;
}

.home-container{height: 100%;}

.toggle-button{
   background-color: #D3DCE6;
   font-size: 10px;
   line-height: 24px;
   text-align: center;
   letter-spacing: 0.2rem;
   cursor: pointer;
}
.el-menu-item.is-active{
   background-color: #434A50!important;
}
</style>
